export default __webpack_public_path__ + "4a7fe745891bc7691ecf7f4c58a828f9.mp4";